import { BProgressBar } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBProgressBar = createEgBootstrapProxy(
  "EgBProgressBar",
  BProgressBar
);
